import { firstValueFrom } from 'rxjs';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { ApplicationConfig, ErrorHandler, provideAppInitializer, inject, provideZonelessChangeDetection } from '@angular/core';

import { GlobalErrorHandler } from './core/observability/global-error.handler';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { baseUrlInterceptor } from './core/interceptors/base-url.interceptor';
import { AppSettingsService } from './core/services/app-settings/app-settings.service';

export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: ErrorHandler, useClass: GlobalErrorHandler },
		provideAppInitializer(() => {
			const appSettingsService = inject(AppSettingsService);
			return firstValueFrom(appSettingsService.loadAll());
		}),
		MessageService,
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
		),
		provideHttpClient(withInterceptors([baseUrlInterceptor, authInterceptor])),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					darkModeSelector: false
				}
			}
		})
	]
};
